/* @flow */
import React from 'react';
import cx from 'classnames';
import './styles/Label.scss';

class Label extends React.Component {
  static propTypes = {
    text: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    divided: React.PropTypes.bool,
    htmlFor: React.PropTypes.string,  // TODO: make required
    hidden: React.PropTypes.bool,
    note: React.PropTypes.string,
  };

  static defaultProps = {
    hidden: false,
  };

  renderNote = () => {
    const { note } = this.props;
    if (!note) {
      return null;
    }
    return <small className="Label-note">{note}</small>;
  };

  render() {
    const { children, hidden, htmlFor, text, className, ...rest } = this.props;

    return (
      <label
        htmlFor={htmlFor}
        {...rest}
        className={cx({
          Label: true,
          'Label-hidden': hidden,
        }, className)}>
        {text}
        {children}
        {this.renderNote()}
      </label>
    );
  }
}

export default Label;



// WEBPACK FOOTER //
// ./src/components/Label.jsx